import React from 'react';
import PropTypes, { any } from 'prop-types';

const Triangle = ({ style }) => {
    return (
        <div style={{ position: 'relative', ...style }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 10 8" fill="none">
                <path d="M1.10289 7.25L5 0.5L8.89712 7.25H1.10289Z" stroke="#828B96" strokeWidth="0.5" />
            </svg>
        </div>
    );
};

export default Triangle;

Triangle.propTypes = {
    style: PropTypes.objectOf(any),
};

Triangle.defaultProps = {
    style: {},
};
